import React from 'react';
import { ButtonWithIcon } from './ButtonWithIcon';
import { HideEyeIcon } from '../../../../../../assests/GmsIcons';

type FooterSectionProps = {
    id?: string;
    config?: {
        showFooter: boolean;
        showDescription: boolean;
        descriptionText: string;
        showPreviousButton: boolean;
        previousButtonText: string;
        previousButtonShowIcon: boolean;
        previousButtonIconUrl?: string;
        previousButtonShowTooltip: boolean;
        previousButtonTooltipText?: string;
        showNextButton: boolean;
        nextButtonText: string;
        nextButtonShowIcon: boolean;
        nextButtonIconUrl?: string;
        nextButtonShowTooltip: boolean;
        nextButtonTooltipText?: string;
    };
    isSelected?: boolean;
};

const FooterSection = ({
    id,
    config = {
        showFooter: true,
        showDescription: true,
        descriptionText: 'Footer Description',
        showPreviousButton: true,
        previousButtonText: 'Previous',
        previousButtonShowIcon: false,
        previousButtonIconUrl: '',
        previousButtonShowTooltip: false,
        previousButtonTooltipText: '',
        showNextButton: true,
        nextButtonText: 'Next',
        nextButtonShowIcon: false,
        nextButtonIconUrl: '',
        nextButtonShowTooltip: false,
        nextButtonTooltipText: ''
    },
    isSelected = false
}: FooterSectionProps) => {
    const baseId = id || 'footer-section';

    return (
        <div
            id={baseId}
            data-testid={baseId}
            className={`tw-relative tw-py-2 tw-px-6 tw-flex tw-justify-between tw-items-center tw-h-auto tw-border-t tw-border-[#DADBDD]
                        ${isSelected ? 'tw-ring-2 tw-bg-[#DADBDD] tw-ring-blue-500' : 'tw-bg-[#F4F5F7]'}`}
        >
            {!config.showFooter && (
                <div className="tw-absolute tw-inset-0 tw-bg-[#F4F5F7] tw-flex tw-items-center tw-justify-center tw-z-10 tw-pointer-events-none">
                    <div className="tw-flex tw-items-center tw-gap-2 tw-text-[#6D788C]">
                        <HideEyeIcon />
                        <span className="tw-font-semibold tw-text-base" style={{ fontFamily: "'Noto Sans', sans-serif" }}>Footer</span>
                    </div>
                </div>
            )}

            {/* Previous Button */}
            <div id={`${baseId}-previous-wrapper`}>
                {config.showPreviousButton && (
                    <ButtonWithIcon
                        id={`${baseId}-previous-btn`}
                        text={config.previousButtonText}
                        showIcon={config.previousButtonShowIcon}
                        iconUrl={config.previousButtonIconUrl}
                        showTooltip={config.previousButtonShowTooltip}
                        tooltipText={config.previousButtonTooltipText}
                    />
                )}
            </div>

            {/* Description in center */}
            {config.showDescription && (
                <div id={`${baseId}-description`} className="tw-flex-1 tw-px-4 tw-text-center">
                    <p className="tw-text-sm tw-text-[#172B4D] tw-truncate tw-max-w-lg tw-mx-auto" title={config.descriptionText}>
                        {config.descriptionText}
                    </p>
                </div>
            )}

            {/* Next Button */}
            <div id={`${baseId}-next-wrapper`}>
                {config.showNextButton && (
                    <ButtonWithIcon
                        id={`${baseId}-next-btn`}
                        text={config.nextButtonText}
                        showIcon={config.nextButtonShowIcon}
                        iconUrl={config.nextButtonIconUrl}
                        showTooltip={config.nextButtonShowTooltip}
                        tooltipText={config.nextButtonTooltipText}
                    />
                )}
            </div>
        </div>
    );
}

export default FooterSection;
